export const getRandomAvatar = () => {
	const imageNumber = Math.floor(Math.random() * 20) + 1; // Generates a number from 1 to 20
	return `/People/dummy/${imageNumber}.png`;
};
